import _globalThis2 from "../internals/global-this";
import _shared from "../internals/shared";
import _hasOwnProperty from "../internals/has-own-property";
import _uid from "../internals/uid";
import _symbolConstructorDetection from "../internals/symbol-constructor-detection";
import _useSymbolAsUid from "../internals/use-symbol-as-uid";
var exports = {};
var _globalThis = _globalThis2;
var shared = _shared;
var hasOwn = _hasOwnProperty;
var uid = _uid;
var NATIVE_SYMBOL = _symbolConstructorDetection;
var USE_SYMBOL_AS_UID = _useSymbolAsUid;
var Symbol = _globalThis.Symbol;
var WellKnownSymbolsStore = shared("wks");
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol["for"] || Symbol : Symbol && Symbol.withoutSetter || uid;
exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name) ? Symbol[name] : createWellKnownSymbol("Symbol." + name);
  }
  return WellKnownSymbolsStore[name];
};
export default exports;